import * as Styles from './Typography.module.scss';

enum TypographyKeys {
    Heading1,
    Heading2,
    Subtitle,
    Body,
    Body2,
    Button1,
    Button2,
    Caption,
    Label,
    Overline
}

enum FontStyle {
    normal,
    oblique,
    italic
}

interface TypographyStyle {
    color?: string;
    family?: string; // Helvetica
    height?: number;
    size?: number; // rem
    spacing?: number; // em
    transform?: string;
    style?: keyof typeof FontStyle; // italic, bold
    weight?: number;
}

export type Typography = Partial<Record<keyof TypographyKeys, TypographyStyle>>;

export const TypographyClassNames: Record<keyof typeof TypographyKeys, string> = {
    Heading1: Styles['heading-1'],
    Heading2: Styles['heading-2'],
    Subtitle: Styles['subtitle'],
    Body: Styles['body'],
    Body2: Styles['body2'],
    Button1: Styles['button-1'],
    Button2: Styles['button-2'],
    Caption: Styles['caption'],
    Label: Styles['label'],
    Overline: Styles['overline']
};
